module.exports = __webpack_public_path__ + "img/injectionsteps_step7.0adc65a1.png";